import logo from '../../assets/Images/logo.png'
const Avvia_Partita = ({ icon, no, text }) => {
    return (
        <div className='difficolta_container Avvia_Partita_container'>
            <div className='difficolta_header'>
                <div className='difficolta_header'>
                    <img src={logo} alt='' className='Avvia_Partita_header_logo' />
                </div>
            </div>
            <div className='Avvia_Partita_center_div'>
                <div>
                    {icon ?
                        <div className='Avvia_Partita_icon_div'>
                            {icon}
                        </div>
                        :
                        <h1 className='Avvia_Partita_center_div_number animate__animated animate__flipInY'>{no}</h1>}
                </div>
            </div>
            {text ? <h1 className='Avvia_Partita_center_text'>{text}</h1> : null}

        </div>
    )
}
export default Avvia_Partita